'use client';

import TopCollectorContainer from './_components';

export default function TopCollectorPage() {
  return <TopCollectorContainer />;
}
